<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Potencial
        </h2>
        <v-text-field
          label="ICTs"
          name="icts"
          type="text"
          v-model="potencial.icts"
          required
          :rules="rules"
          background-color="white"
        />

        <v-textarea
          label="Atrativos econômicos"
          name="atrativosEconomicos"
          type="text"
          v-model="potencial.atrativosEconomicos"
          required
          :rules="rules"
          background-color="white"
        />
        <v-textarea
          label="Observações"
          name="observacoes"
          type="text"
          v-model="potencial.observacoes"
          required
          :rules="rules"
          background-color="white"
        />
        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { potencialApi } from "../Api/potencial";
export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      potencial: {},
      payload: {
        municipioId: this.$route.params.id,
      },
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      potencialApi
        .find(this.tabId)
        .then(({ data }) => {
          this.potencial = data;
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Potencial");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.potencial.municipioId = this.payload.municipioId;

      if (this.tabId > 0) {
        potencialApi
          .update(this.potencial)
          .then(() => {
            this.$notification.success("Potencial editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Ator");
            console.log("Erro no submit ", err);
          });
      } else {
        potencialApi
          .create(this.potencial)
          .then(() => {
            this.$notification.success("Potencial criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Potencial");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}
</style>
